module.exports = __webpack_public_path__ + "img/media-presence-3.23cbbcb4.png";